export default __webpack_public_path__ + "static/media/turkey-flag.b92bbaa2.svg";